import React from 'react';

export const Button = ({ children, onClick, variant = 'primary', className = '', disabled = false, ...props }) => {
  const baseStyle = "px-4 py-2 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center justify-center gap-2";
  const variants = {
    primary: "bg-[hsl(var(--brand-blue))] text-white hover:bg-blue-700 focus:ring-blue-500",
    secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-gray-400",
    outline: "border border-gray-300 text-gray-700 hover:bg-gray-50",
    ghost: "text-gray-600 hover:bg-gray-100 hover:text-gray-900",
  };
  
  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
    {children}
  </div>
);

export const Tabs = ({ activeTab, setActiveTab, tabs }) => (
  <div className="flex items-center gap-1">
    {tabs.map(tab => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${
          activeTab === tab.id
            ? 'bg-[#fef9c3] text-slate-900 shadow-md ring-1 ring-yellow-200/60 -translate-y-px'
            : 'text-white/80 hover:text-white hover:bg-white/5'
        }`}
        data-testid={`tab-${tab.id}`}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
